import { render, staticRenderFns } from "./ResetTOTP.vue?vue&type=template&id=28170b9a&"
import script from "./ResetTOTP.vue?vue&type=script&lang=ts&"
export * from "./ResetTOTP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports